export const tourSteps = [
    {
        selector: ".trends-tickets",
        content: "View your weekly ticket stats here."
    },
    {
        selector: ".notification-header-panel",
        content: 'Your Notification Panel.',
    },
    {
        selector: ".tickets-filter-table",
        content: "A quick overview of your tickets. You can filter and view tickets by status."
    },
    {
        selector: ".tickets-largest-departments",
        content: "See your top departments."
    },
    {
        selector: ".tickets-top-tags",
        content: "Discover your most used tags."
    },
    {
        selector: ".profile-panel-header",
        content: 'Adjust account settings here.',
    }
];

export const fakeDashboard = {
    avgFirstResponseTime: "12 minutes",
    avgResponseTime: "5 minutes",
    closedTickets: 720,
    receivedTickets: 735,
    dailyTickets: {
        monday: 10,
        tuesday: 8,
        wednesday: 12,
        thursday: 15,
        friday: 16,
        saturday: 7,
        sunday: 8
    },
    ticketsCount: {
        open: 32,
        active: 9,
        MyTickets: 42,
        pending: 10,
        closed: 13
    },
    // Tickets Created — last 30 days line chart
    dailyTicketsChart: (() => {
        const base = [4,2,6,5,8,3,1,7,9,4,6,3,5,8,11,7,4,6,2,9,5,3,8,6,4,7,10,5,3,6];
        return base.map((count, i) => {
            const d = new Date();
            d.setDate(d.getDate() - (29 - i));
            return { date: d.toISOString().slice(0, 10), count };
        });
    })(),
    // Resolved Tickets — last 30 days line chart
    resolvedTicketsChart: (() => {
        const base = [3,1,5,4,7,2,1,6,8,3,5,2,4,7,9,6,3,5,1,8,4,2,7,5,3,6,9,4,2,5];
        return base.map((count, i) => {
            const d = new Date();
            d.setDate(d.getDate() - (29 - i));
            return { date: d.toISOString().slice(0, 10), count };
        });
    })(),
    // Avg Response Time — last 30 days line chart ({ date, seconds, label })
    avgResponseTimeChart: (() => {
        const secondsBase = [720,540,900,660,480,1020,780,600,840,720,540,660,900,480,720,600,840,720,540,900,660,480,780,600,720,840,540,660,900,720];
        return secondsBase.map((seconds, i) => {
            const d = new Date();
            d.setDate(d.getDate() - (29 - i));
            const m = Math.floor(seconds / 60);
            const s = seconds % 60;
            return {
                date: d.toISOString().slice(0, 10),
                seconds,
                label: s > 0 ? `${m}m ${s}s` : `${m}m`,
            };
        });
    })(),
    // Tickets by Priority — pie chart
    priorityData: [
        { name: 'Critical', color: '#dc2626', tickets_count: 8  },
        { name: 'High',     color: '#f97316', tickets_count: 14 },
        { name: 'Medium',   color: '#eab308', tickets_count: 22 },
        { name: 'Low',      color: '#22c55e', tickets_count: 11 },
    ],
    // Claritask Comparison — doughnut chart
    claritaskTicketStats: { single: 38, linked: 17 },
    // Tickets per Agent — bar chart
    ticketsPerAgent: [
        { agent_name: 'Noah Smith',   tickets_count: 21 },
        { agent_name: 'Jasmine Kim',  tickets_count: 17 },
        { agent_name: 'Fred Brown',   tickets_count: 14 },
        { agent_name: 'Sara Lee',     tickets_count: 11 },
        { agent_name: 'Tom Clark',    tickets_count: 9  },
    ],
    // Top Agents — resolved tickets all-time
    topAgents: [
        { user_id: 1, agent_name: 'Noah Smith',  resolved_count: 134 },
        { user_id: 2, agent_name: 'Jasmine Kim', resolved_count: 112 },
        { user_id: 3, agent_name: 'Fred Brown',  resolved_count: 98  },
        { user_id: 4, agent_name: 'Sara Lee',    resolved_count: 76  },
        { user_id: 5, agent_name: 'Tom Clark',   resolved_count: 61  },
    ],
    ticketsOverview: [{
        id: 1,
        title: "Problem with placing my order",
        status: { name: "Open",    color: "#6bcef8" },
        department: { name: "Sales",      color: "#66BB6A" },
    }, {
        id: 2,
        title: "The website is slow",
        status: { name: "Active",  color: "#79e275" },
        department: { name: "IT Support", color: "#757575" },
        user: { name: "Noah Smith",  profile_image: "" }
    }, {
        id: 3,
        title: "The promotional video is not working",
        status: { name: "Active",  color: "#79e275" },
        department: { name: "Marketing",  color: "#42A5F5" },
        user: { name: "Jasmine Kim", profile_image: "" }
    }, {
        id: 4,
        title: "Payment is pending for my order",
        status: { name: "Pending", color: "#f9d6b5" },
        department: { name: "Sales",      color: "#66BB6A" },
        user: { name: "Fred Brown",  profile_image: "" }
    }],
    departments: [
        { name: "IT Support", color: "#757575", tickets_count: 20 },
        { name: "Sales",      color: "#66BB6A", tickets_count: 5  },
        { name: "Marketing",  color: "#42A5F5", tickets_count: 3  },
    ],
    tags: [
        { name: "Urgent",         color: "#F44336", tickets_count: 10 },
        { name: "Needs Attention", color: "#FFA000", tickets_count: 26 },
        { name: "Under Review",   color: "#00ACC1", tickets_count: 5  },
        { name: "Inquiry",        color: "#5E35B1", tickets_count: 2  },
        { name: "Feedback",       color: "#4CAF50", tickets_count: 12 },
    ],
};
